import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { selectAuthStatus } from 'features/auth/authSlice';
import { Navigate, Outlet, useLocation } from 'react-router';
import { routes } from 'routes/routes';
import { useAppSelector } from 'store/hooks';

const loadingFallback = <Spinner text='Loading' isFullScreen show />;

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export const getPostLoginPath = (navigationState: unknown) => {
    if (!isRecord(navigationState) || !isRecord(navigationState.from)) {
        return `/${routes.TRANSPORT_ORDERS}`;
    }

    const { pathname, search = '', hash = '' } = navigationState.from;
    if (
        typeof pathname !== 'string' ||
        !pathname.startsWith('/') ||
        pathname === `/${routes.LOGIN}` ||
        typeof search !== 'string' ||
        typeof hash !== 'string'
    ) {
        return `/${routes.TRANSPORT_ORDERS}`;
    }

    return `${pathname}${search}${hash}`;
};

export const RequireAuth = () => {
    const status = useAppSelector(selectAuthStatus);
    const location = useLocation();

    if (status === 'loading') {
        return loadingFallback;
    }

    if (status === 'unauthenticated') {
        return <Navigate to={`/${routes.LOGIN}`} replace state={{ from: location }} />;
    }

    return <Outlet />;
};

export const RequireGuest = () => {
    const status = useAppSelector(selectAuthStatus);
    const location = useLocation();

    if (status === 'loading') {
        return loadingFallback;
    }

    if (status === 'authenticated') {
        return <Navigate to={getPostLoginPath(location.state)} replace />;
    }

    return <Outlet />;
};
